import { IPayrollSettings } from "@wingspanhq/payments/dist/interfaces";
import { IClient } from "@wingspanhq/users/dist/lib/interfaces";
import { selectorHasPaymentMethod } from "./selectorHasPaymentMethod";

export const selectorHasFundingMethod = (
  payrollSettings?: IPayrollSettings,
  client?: IClient
) => !!payrollSettings?.fundingSource || selectorHasPaymentMethod(client);
